let alertTimeout

function showAlert(message, type = 'success', duration = 3000) {
  const alert = document.getElementById('alert-notification')
  const alertText = document.getElementById('alert-text')

  if (alertTimeout) {
    clearTimeout(alertTimeout)
  }

  alertText.textContent = message
  alert.classList.remove('success', 'error', 'warning')
  alert.classList.add(type)
  alert.classList.add('show')

  if (duration > 0) {
    alertTimeout = setTimeout(() => {
      closeAlert()
    }, duration)
  }
}

function closeAlert() {
  const alert = document.getElementById('alert-notification')
  alert.classList.remove('show')

  if (alertTimeout) {
    clearTimeout(alertTimeout)
    alertTimeout = null
  }
}

// Função global para mostrar alertas (usada pelo carrinho)
window.mostrarAlerta = function (message, type = 'success') {
  showAlert(message, type)
}

// Função para adicionar ao carrinho
function addToCart(variantId, button, productTitle) {
  button.classList.add('loading')
  button.disabled = true

  // Primeiro verificar se o produto já está no carrinho
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cartData) => {
      // Verificar se o produto já existe no carrinho
      const existingItem = cartData.items.find((item) => item.variant_id.toString() === variantId.toString())

      if (existingItem) {
        // Produto já existe no carrinho
        mostrarAlerta('Só é permitida uma unidade por produto no carrinho!', 'warning')
        button.classList.remove('loading')
        button.disabled = false
        return
      }

      // Se não existe, adicionar ao carrinho
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        })
      })
    })
    .then((response) => {
      if (!response) return // Se o produto já existia, não faz nada
      return response.json()
    })
    .then((data) => {
      if (!data) return // Se o produto já existia, não faz nada

      // Atualizar contador do carrinho
      if (window.atualizarContadorCarrinho) {
        window.atualizarContadorCarrinho()
      }
      if (window.updateCartDisplay) {
        window.updateCartDisplay()
      }

      mostrarAlerta('Produto adicionado ao carrinho!', 'success')
    })
    .catch((error) => {
      console.error('Erro ao adicionar ao carrinho:', error)
      mostrarAlerta('Erro ao adicionar produto ao carrinho!', 'error')
    })
    .finally(() => {
      button.classList.remove('loading')
      button.disabled = false
    })
}

// Expor função globalmente
window.addToCart = addToCart

// Função para buscar produtos (reutilizável para desktop e mobile)
function buscarProdutos(termo, resultadosContainer) {
  if (termo.length < 1) {
    resultadosContainer.style.display = 'none'
    resultadosContainer.innerHTML = ''
    return
  }

  resultadosContainer.innerHTML = '<div class="resultado-item buscando"><span class="loading"></span></div>'
  resultadosContainer.style.display = 'flex'

  fetch(`/search/suggest.json?q=${encodeURIComponent(termo)}&resources[type]=product&resources[limit]=5`)
    .then((res) => res.json())
    .then((data) => {
      const produtos = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : []
      if (produtos.length === 0) {
        resultadosContainer.innerHTML = '<div class="sem-resultado">Nenhum produto encontrado.</div>'
        return
      }
      resultadosContainer.innerHTML = produtos
        .map(
          (produto) => `
        <a href="${produto.url}" class="resultado-item">
          <div class="foto" style="background-image: url('${produto.image || '/assets/categoria-camisetas.png'}')"></div>
          <span>${produto.title}</span>
        </a>
      `
        )
        .join('')
    })
    .catch(() => {
      resultadosContainer.innerHTML = '<div class="sem-resultado">Erro ao buscar produtos.</div>'
    })
}

document.addEventListener('DOMContentLoaded', () => {
  // Atualizar contador do carrinho quando a página carregar
  setTimeout(() => {
    if (window.atualizarContadorCarrinho) {
      window.atualizarContadorCarrinho()
    }
  }, 500)

  // Busca do nav (desktop)
  const buscaInput = document.querySelector('nav .busca input')
  const resultadosBusca = document.querySelector('nav .busca .resultados-busca')

  if (buscaInput && resultadosBusca) {
    let timeoutBusca
    buscaInput.addEventListener('input', function () {
      const termo = this.value.trim()
      clearTimeout(timeoutBusca)
      if (termo.length < 1) {
        resultadosBusca.style.display = 'none'
        resultadosBusca.innerHTML = ''
        return
      }
      // Pequeno delay para evitar requisições em excesso
      timeoutBusca = setTimeout(() => {
        buscarProdutos(termo, resultadosBusca)
      }, 200)
    })
    // Esconde o balão ao clicar fora
    document.addEventListener('click', function (e) {
      if (!buscaInput.contains(e.target) && !resultadosBusca.contains(e.target)) {
        resultadosBusca.style.display = 'none'
      }
    })
    // Mostra o balão ao focar se já tem texto
    buscaInput.addEventListener('focus', function () {
      if (this.value.trim().length > 0 && resultadosBusca.innerHTML) {
        resultadosBusca.style.display = 'flex'
      }
    })
  }

  // Busca mobile
  const buscaMobileOverlay = document.querySelector('.busca-mobile-overlay')
  const buscaMobileInput = document.querySelector('.busca-mobile-input')
  const resultadosBuscaMobile = document.querySelector('.resultados-busca-mobile')
  const fecharBuscaMobile = document.querySelector('.fechar-busca-mobile')
  const iconeBuscaMobile = document.querySelector('nav .busca .icone')

  if (buscaMobileOverlay && buscaMobileInput && resultadosBuscaMobile) {
    let timeoutBuscaMobile

    // Abrir overlay ao clicar no ícone de busca (mobile)
    if (iconeBuscaMobile) {
      iconeBuscaMobile.addEventListener('click', function () {
        buscaMobileOverlay.style.display = 'flex'
        setTimeout(() => {
          buscaMobileInput.focus()
        }, 100)
      })
    }

    // Fechar overlay
    if (fecharBuscaMobile) {
      fecharBuscaMobile.addEventListener('click', function () {
        buscaMobileOverlay.style.display = 'none'
        buscaMobileInput.value = ''
        resultadosBuscaMobile.style.display = 'none'
        resultadosBuscaMobile.innerHTML = ''
      })
    }

    // Fechar ao clicar fora do container
    buscaMobileOverlay.addEventListener('click', function (e) {
      if (e.target === buscaMobileOverlay) {
        buscaMobileOverlay.style.display = 'none'
        buscaMobileInput.value = ''
        resultadosBuscaMobile.style.display = 'none'
        resultadosBuscaMobile.innerHTML = ''
      }
    })

    // Busca no input mobile
    buscaMobileInput.addEventListener('input', function () {
      const termo = this.value.trim()
      clearTimeout(timeoutBuscaMobile)
      timeoutBuscaMobile = setTimeout(() => {
        buscarProdutos(termo, resultadosBuscaMobile)
      }, 200)
    })

    // Fechar ao pressionar ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && buscaMobileOverlay.style.display === 'flex') {
        buscaMobileOverlay.style.display = 'none'
        buscaMobileInput.value = ''
        resultadosBuscaMobile.style.display = 'none'
        resultadosBuscaMobile.innerHTML = ''
      }
    })
  }
})

// Banner Slider Functions
let slideAtual = 0
let totalSlides = 0
let slidesWrapper = null
let slides = []
let indicadores = []

function initBannerSlider() {
  slidesWrapper = document.querySelector('.slides-wrapper')
  if (!slidesWrapper) return

  slides = document.querySelectorAll('.slide-item')
  indicadores = document.querySelectorAll('.indicador')
  totalSlides = slides.length

  // Suporte a arrastar (swipe)
  let inicioX = 0
  let arrastando = false
  const banner = document.querySelector('.banner')

  if (banner && totalSlides > 1) {
    // Mouse events
    banner.addEventListener('mousedown', (e) => {
      inicioX = e.clientX
      arrastando = true
      banner.style.cursor = 'grabbing'
    })

    banner.addEventListener('mousemove', (e) => {
      if (!arrastando) return
      e.preventDefault()
    })

    banner.addEventListener('mouseup', (e) => {
      if (!arrastando) return
      arrastando = false
      banner.style.cursor = 'grab'

      const fimX = e.clientX
      const distancia = inicioX - fimX

      if (Math.abs(distancia) > 50) {
        if (distancia > 0) {
          proximoSlide()
        } else {
          anteriorSlide()
        }
      }
    })

    banner.addEventListener('mouseleave', () => {
      arrastando = false
      banner.style.cursor = 'default'
    })

    // Touch events para mobile
    banner.addEventListener('touchstart', (e) => {
      inicioX = e.touches[0].clientX
    })

    banner.addEventListener('touchend', (e) => {
      const fimX = e.changedTouches[0].clientX
      const distancia = inicioX - fimX

      if (Math.abs(distancia) > 50) {
        if (distancia > 0) {
          proximoSlide()
        } else {
          anteriorSlide()
        }
      }
    })
  }
}

function proximoSlide() {
  if (totalSlides <= 1) return
  slideAtual = (slideAtual + 1) % totalSlides
  atualizarSlide()
}

function anteriorSlide() {
  if (totalSlides <= 1) return
  slideAtual = (slideAtual - 1 + totalSlides) % totalSlides
  atualizarSlide()
}

function irParaSlide(index) {
  if (totalSlides <= 1) return
  slideAtual = index
  atualizarSlide()
}

function atualizarSlide() {
  if (!slidesWrapper || totalSlides <= 1) return

  // Move o container de slides
  slidesWrapper.style.transform = `translateX(-${slideAtual * 100}%)`

  // Atualiza classes ativas
  slides.forEach((slide, index) => {
    slide.classList.toggle('ativo', index === slideAtual)
  })

  indicadores.forEach((indicador, index) => {
    indicador.classList.toggle('ativo', index === slideAtual)
  })
}

// Inicializar banner slider quando a página carregar
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    initBannerSlider()
  }, 100)
})
